import React from 'react';
import Banner from '../components/Banner';
import Navigation from '../components/navigation2';
import Footer from '../components/Footer';
import logo2 from '../assets/logo2.png';
import booki from '../assets/booki.png';
import '../styles/pages/realisation.css';

const Realisation = () => {
    return (
        <div>
            <Banner />
            <Navigation />
            <h1 className='realisation_titre'>Mes réalisations</h1>
            <h2 className='realisation_texte'>Voici quelques exemples de projets que j'ai réalisés pour mes clients.</h2>
            <h2>Chaque projet est unique et adapté aux besoins spécifiques de chaque client.</h2>
            <div className='realisation'>
                <h2>La spirulinère</h2>
                <p>Un jeune producteur de spiruline souhaitait plus de visibilité pour se faire connaitre.</p>
                <p>La mise en place d'une boutique de ecommerce, lui permet maintenant de vendre ces produits depuis son site web</p>
                {/* <p>Pour découvrir ce producteur de spiruline 100% paysanne</p>
                <p>cliquez-ici !</p> */}
            </div>
            <div className='realisation'>
                <h2>Montceau Loft</h2>
                <p>Location d'un logements de standing pour des séjours de courte durée.</p>
                <p>Grace à un site web moderne et attractif, les clients peuvent facilement découvrir les offres de logements.</p>
                <p>Le site web permet aussi aux clients de le contacter facilement pour des commandes spéciales.</p>
                {/* <p>Pour visualiser le site web,</p>
                <p>cliquez-ici</p> */}

            </div>
            {/* <div className='realisation'>
                <h2>Ohmyfood</h2>
                <p>Projet de site de réservation d'un restaurant avec le menu</p>
                <p>Pour visualiser, la partie du site web réalisée,</p>
                <p>cliquez-ici</p>
            </div> */}
            <div className='realisation_booki'>
                <div>
                    <h2>Booki</h2>
                    <p>Projet de site de réservation d'hébergement pour des vacances de rêve</p>
                    <p>Arroweb Developpement à participé à la mise en place du design du site</p>
                </div>
                <div>
                    <img
                        src={booki}
                        alt="Booki"
                        className='booki_image'
                        onClick={() => window.open(booki, '_blank')}
                        style={{ cursor: 'pointer' }}
                    />
                </div>
                {/* <p>Pour visualiser le site web,</p>
                <p>cliquez-ici</p> */}
            </div>
            <div className='realisation'>
                <h2>Kanap</h2>
                <p>Projet de site d'achat de canapé en ligne</p>
                <p>Arroweb Developpement à participé à la mise en place de la base de donées et à la gestion des commandes</p>
                {/* <p>Pour visualiser le site web,</p>
                <p>cliquez-ici</p> */}
            </div>
            {/* <div className='realisation'>
                <h2>Piiquante</h2>
                <p>Site web recensant les sauces des utilisateurs</p>
                <p>Arroweb Developpement à le backend pour l'accès à la base de donnée et la gestion des likes</p>
                <p>Pour un apercu du site web,</p>
                <p>cliquez-ici</p>
            </div> */}
            {/* <div className='realisation'>
                <h2>Groupomania</h2>
                <p>Réseau social interne d'entreprise</p>
                <p>Arroweb Developpement à créer le fontend, le backend et à mis en place la base de données</p> */}
            {/* <p>Pour un apercu du site web,</p>
                <p>cliquez-ici</p> */}
            {/* </div> */}
            <div className='realisationFutur'>
                <h2>Et bien d'autres à venir...</h2>
                <p>De nouveaux projets sont en cours de réalisation</p>
                <img src={logo2} alt="fleche" className='flechelogo2' />
            </div>
            <Footer />
        </div>
    );
};

export default Realisation;